import React from 'react';
import PropTypes from 'prop-types';
import { useIntl, defineMessages } from 'react-intl';

import CCRadioButton from 'components/shared/DesignSystem/SlabTransferPortal/CCRadioButton';
import RadioWrap from './RadioWrap';
import GroupTitle from './GroupTitle';

const messages = defineMessages({
  title: {
    id: 'AssetFeed.ViewMenu.AssetSizeToggle.title',
    defaultMessage: 'Photo Size',
    description: 'View menu asset size title',
  },
  labelSmall: {
    id: 'AssetFeed.ViewMenu.AssetSizeToggle.labelSmall',
    defaultMessage: 'Small',
    description: 'Label for toggling asset size to small',
  },
  labelMedium: {
    id: 'AssetFeed.ViewMenu.AssetSizeToggle.labelMedium',
    defaultMessage: 'Medium',
    description: 'Label for toggling asset size to medium',
  },
  labelLarge: {
    id: 'AssetFeed.ViewMenu.AssetSizeToggle.labelLarge',
    defaultMessage: 'Large',
    description: 'Label for toggling asset size to large',
  },
});

const AssetSizeToggle = ({ setAssetSize, assetSize }) => {
  const { formatMessage } = useIntl();

  return (
    <div>
      <GroupTitle>{formatMessage(messages.title)}</GroupTitle>
      <RadioWrap>
        <CCRadioButton
          id="asset-size-selector-small"
          label={formatMessage(messages.labelSmall)}
          value="small"
          layout="inline"
          name="asset-size-selector"
          onChange={(checked) => {
            if (checked) {
              setAssetSize('small');
            }
          }}
          checked={assetSize === 'small'}
          data-testid="view_menu__size-small"
        />
        <CCRadioButton
          id="asset-size-selector-medium"
          label={formatMessage(messages.labelMedium)}
          value="medium"
          layout="inline"
          name="asset-size-selector"
          onChange={(checked) => {
            if (checked) {
              setAssetSize('medium');
            }
          }}
          checked={assetSize === 'medium'}
          data-testid="view_menu__size-medium"
        />
        <CCRadioButton
          id="asset-size-selector-large"
          label={formatMessage(messages.labelLarge)}
          value="large"
          layout="inline"
          name="asset-size-selector"
          onChange={(checked) => {
            if (checked) {
              setAssetSize('large');
            }
          }}
          checked={assetSize === 'large'}
          data-testid="view_menu__size-large"
        />
      </RadioWrap>
    </div>
  );
};

AssetSizeToggle.propTypes = {
  setAssetSize: PropTypes.func,
  assetSize: PropTypes.string,
};

export default AssetSizeToggle;
